
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-167f3b98&scoped=true!../../../../vue-loader/lib/selector?type=styles&index=0!./ScalingSquaresSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./ScalingSquaresSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-167f3b98!../../../../vue-loader/lib/selector?type=template&index=0!./ScalingSquaresSpinner.vue"),
  /* scopeId */
  "data-v-167f3b98",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/ScalingSquaresSpinner.vue
// module id = 871
// module chunks = 1